/**
 * Thành phần gốc ứng dụng - App Root Component
 *
 * Chức năng:
 * - Khởi tạo và cập nhật favicon/logo của cơ sở
 * - Cung cấp router cho toàn bộ ứng dụng
 */
import React, { useEffect } from 'react';
import AppRouter from './routes/router';
import { applyFavicon, loadCachedFaviconLogoPath } from './utils/branding';

const App: React.FC = () => {
  useEffect(() => {
    applyFavicon(loadCachedFaviconLogoPath());
  }, []);

  return <AppRouter />;
};

export default App;
